export default __webpack_public_path__ + "static/locate_white-0aeb9d3a751523d689b54e37a9dbe94e.png";